import CloseIcon from '@mui/icons-material/Close';
import {
	CircularProgress,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Link,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material';
import { useQuery } from '@parkchirp/api-client';
import dynamic from 'next/dynamic';
import { useState } from 'react';

import { LIST_PAYMENT_LOGS } from '../../queries';

const JSONViewer = dynamic(() => import('@microlink/react-json-view'), {
	ssr: false,
});

export const PaymentLogs = ({ subscriptionId, invoiceId }: { subscriptionId?: string; invoiceId?: string }) => {
	const [selectedMeta, setSelectedMeta] = useState(null);
	const [selectedMetaName, setSelectedMetaName] = useState(null);

	const handleOpenMeta = (meta, name) => {
		setSelectedMeta(meta);
		setSelectedMetaName(name);
	};

	const handleCloseMeta = () => {
		setSelectedMeta(null);
		setSelectedMetaName(null);
	};

	const { data, loading: isLoading } = useQuery(LIST_PAYMENT_LOGS, {
		context: { apiVersion: 'v2' },
		variables: {
			...(subscriptionId && { subscriptionId }),
			...(invoiceId && { invoiceId }),
			order: {
				field: 'createdAt',
				sort: 'desc',
			},
		},
	});

	return (
		<>
			<TableContainer component={Paper} sx={{ marginTop: '2em' }}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell>Facility</TableCell>
							<TableCell>Facility Number</TableCell>
							<TableCell>Invoice Id</TableCell>
							<TableCell>Payment Reference Id</TableCell>
							<TableCell>Payment Method</TableCell>
							<TableCell>Status</TableCell>
							<TableCell>Type</TableCell>
							<TableCell>Last 4</TableCell>
							<TableCell>Payment Meta</TableCell>
							<TableCell>Void Meta</TableCell>
							<TableCell>Created At</TableCell>
							<TableCell>Updated At</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{isLoading ? (
							<TableRow>
								<TableCell colSpan={11} align='center'>
									<CircularProgress size={24} />
								</TableCell>
							</TableRow>
						) : data?.listPaymentLogs?.data?.length ? (
							data.listPaymentLogs.data.map((row) => (
								<TableRow key={row.id}>
									<TableCell>{row.facilityName ?? ''}</TableCell>
									<TableCell>{row.facilityNumber ?? ''}</TableCell>
									<TableCell>{row.invoiceId}</TableCell>
									<TableCell>{row.paymentReferenceId}</TableCell>
									<TableCell>{row.paymentMethodType}</TableCell>
									<TableCell>{row.paymentStatus}</TableCell>
									<TableCell>{row.type}</TableCell>
									<TableCell>{row.last4}</TableCell>
									<TableCell>
										{row.paymentMeta ? (
											<Link
												component='button'
												onClick={() => handleOpenMeta(row.paymentMeta, 'Payment')}
											>
												View
											</Link>
										) : (
											'-'
										)}
									</TableCell>
									<TableCell>
										{row.voidMeta ? (
											<Link
												component='button'
												onClick={() => handleOpenMeta(row.voidMeta, 'Void')}
											>
												View
											</Link>
										) : (
											'-'
										)}
									</TableCell>
									<TableCell>{new Date(Number.parseInt(row.createdAt, 10)).toUTCString()}</TableCell>
									<TableCell>{new Date(Number.parseInt(row.updatedAt, 10)).toUTCString()}</TableCell>
								</TableRow>
							))
						) : (
							<TableRow>
								<TableCell colSpan={11} align='center'>
									No payment logs
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			<Dialog open={!!selectedMeta} onClose={handleCloseMeta} maxWidth='md' fullWidth>
				<DialogTitle>
					{selectedMetaName} Meta
					<IconButton
						onClick={handleCloseMeta}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<JSONViewer
						src={selectedMeta}
						name={false}
						collapsed={2}
						enableClipboard
						displayDataTypes={false}
					/>
				</DialogContent>
			</Dialog>
		</>
	);
};
